import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const mockCredentials = {
    email: 'admin@naver.com',
    password: 'admin1234'
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex?.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors?.[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    const newErrors = {};

    if (!formData?.email?.trim()) {
      newErrors.email = '이메일을 입력해주세요';
    } else if (!validateEmail(formData?.email)) {
      newErrors.email = '올바른 이메일 형식이 아닙니다';
    }

    if (!formData?.password?.trim()) {
      newErrors.password = '비밀번호를 입력해주세요';
    } else if (formData?.password?.length < 6) {
      newErrors.password = '비밀번호는 최소 6자 이상이어야 합니다';
    }

    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      if (formData?.email === mockCredentials?.email && formData?.password === mockCredentials?.password) {
        try {
          localStorage.setItem('picklelink.superAdminAuthed', 'true');
        } catch (e2) {
          // ignore
        }

        const target = location?.state?.from || '/super-admin/admins';
        navigate(target);
      } else {
        setErrors({
          general: '이메일 또는 비밀번호가 올바르지 않습니다'
        });
        setIsLoading(false);
      }
    }, 600);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-xl shadow-lg border border-border p-6 md:p-8 lg:p-10">
          <div className="flex flex-col items-center mb-6 md:mb-8">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-warning/10 rounded-xl flex items-center justify-center mb-4">
              <Icon name="Shield" size={32} color="var(--color-warning)" />
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground text-center mb-2">
              슈퍼관리자
            </h1>
            <p className="text-sm caption text-muted-foreground text-center">
              PickleLink 관리자를 등록하고 관리합니다
            </p>
          </div>

          {errors?.general && (
            <div className="bg-error/10 border border-error/20 rounded-md p-4 flex items-start gap-3 mb-6">
              <Icon name="AlertCircle" size={20} color="var(--color-error)" />
              <p className="text-sm text-error">{errors?.general}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <Input
              label="이메일"
              type="email"
              name="email"
              placeholder="admin@naver.com"
              value={formData?.email}
              onChange={handleInputChange}
              error={errors?.email}
              required
              disabled={isLoading}
            />

            <div className="relative">
              <Input
                label="비밀번호"
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="비밀번호"
                value={formData?.password}
                onChange={handleInputChange}
                error={errors?.password}
                required
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                className="absolute right-3 top-[2.65rem] text-muted-foreground hover:text-foreground"
                aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 표시'}
                disabled={isLoading}
              >
                <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={18} />
              </button>
            </div>

            <div className="flex gap-3 pt-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => navigate('/')}
                disabled={isLoading}
                fullWidth
              >
                홈
              </Button>

              <Button
                type="submit"
                variant="warning"
                loading={isLoading}
                iconName="LogIn"
                iconPosition="right"
                fullWidth
              >
                로그인
              </Button>
            </div>
          </form>

          <div className="mt-6 pt-6 border-t border-border">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={16} className="text-muted-foreground mt-0.5" />
              <p className="text-sm caption text-muted-foreground">
                이 화면은 프론트엔드만으로 동작하는 임시 로그인입니다. 서버 연동 시 실제 인증으로 교체됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
